import { UserType } from 'types';

export function hasPermission(user: UserType, portId: number, findRoles: string[], op: 'AND' | 'OR' = 'OR'): boolean {
    if (findRoles.length === 0) {
        return true;
    }

    if (findRoles[0] === 'isAdmin') {
        return user.type === 'systemAdministrator';
    }
    const findRole = user.user_rules.filter((x) => {
        return findRoles.includes(x.function) && portId === x.port_id;
    });
    if (findRole.length > 0 && op === 'OR') {
        return true;
    }

    if (findRole.length === findRoles.length && op === 'AND') {
        return true;
    }

    return false;
}

export function userTypeForPort(user: UserType, portId): string {
    const userPort = user.user_ports.find((x) => {
        return x.port_id === portId;
    });

    if (userPort) {
        return userPort.user_type === 'systemAdministrator' ? 'portAdministrator' : userPort.user_type;
    }

    return 'guest';
}
